export function titularRemitente (titularDeCupo, cuentayorden) {
  return {
    titularCp: cuentayorden || titularDeCupo,
    remitente: cuentayorden ? titularDeCupo : cuentayorden
  }
}

export function titularCupoCuentayorden (titularCp, remitente) {
  return {
    titularDeCupo: remitente || titularCp,
    cuentayorden: remitente ? titularCp : remitente
  }
}

export function reducirCosecha (cosecha) {
  return cosecha ? String(cosecha).slice(2) : ''
}

export function expandirCosecha (cosecha) {
  return String(Number(cosecha) - 1) + String(cosecha)
}
